<template>
  <b-card>
    <div v-if="errorResponse === null" class="success text-center">
      <img width="385" height="287" alt="upload success" :src="uploadSuccessImg" />
      <h5 class="mt-2 mb-3">
        {{ $t('global.title.importResult') }}
      </h5>
      <p>{{ $t('global.subtitle.importResult') }}</p>
      <McButton
        :text="$t('fleetTaskInstant.action.viewResult')"
        icon="icon-outline_checkmark"
        @click="$router.push('/fleet-task?type=instant')"
      />
    </div>

    <div v-else>
      <McAlert
        withIcon
        variant="error"
        class="alert-error"
        :text="$t('fleetTaskInstant.text.invalidTemplate')"
      />

      <template v-if="errorItems.length > 0">
        <b-table
          responsive
          bordered
          class="error-table mt-4 mb-4"
          :fields="fields"
          :items="errorItems"
        >
          <template #cell(icon-col)>
            <i class="icon-outline_close" />
          </template>
        </b-table>
  
        <p>{{ `${$t('global.text.displays')} ${errorItems.length} ${$t('global.text.data')}` }}</p>
      </template>
    </div>
  </b-card>
</template>

<script>
import McButton from '@/components/McButton'
import McAlert from '@/components/McAlert'

import uploadSuccessImg from '@/assets/images/upload-success.png'
import { codeMapping, setInvalidFormatMessage } from '../lib/constants/error-message'

export default {
  components: {
    McButton,
    McAlert,
  },
  props: {
    errorResponse: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      uploadSuccessImg,
      fields: [
        {
          key: 'icon-col',
          label: '',
          tdClass: '__icon-col',
        },
        {
          key: 'sheet',
          label: 'Sheet',
        },
        {
          key: 'location',
          label: this.$t('global.field.location'),
        },
        {
          key: 'reason',
          label: this.$t('fleetTaskInstant.field.reason'),
        },
      ],
    }
  },
  computed: {
    errorItems() {
      if (this.errorResponse === null || !this.errorResponse?.issues) {
        return []
      }

      // TODO: refactor the logic to set location and reason columns
      return this.errorResponse.issues.map((item) => {
        const path = item.path

        // set reason value
        let reason = codeMapping[item.code]
        if (typeof reason === 'function') {
          reason = reason()
        }
        
        if (item.code === 'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.INVALID_FORMAT') {
          reason = setInvalidFormatMessage(path[path.length - 1], item.message)
        }

        // set location value
        let location = ''

        if (
          item.code === 'FLEET_TASK.FLEET_TASK_INSTANT.IMPORT.QUICK_ASSIGNMENT_ID_NOT_FOUND' ||
          path[3] === '-'
        ) {
          location = 'Row ' + path[2]
        } else {
          location = 'ID ' + path[3]
        }

        return {
          sheet: path[1],
          reason,
          location,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.alert-error {
  width: fit-content;
}

:deep(.error-table) {
  max-height: 1000px;

  .__icon-col {
    background-color: #fee8e5;
    width: 44px;

    i {
      font-size: 20px;

      &:before {
        color: $red;
      }
    }
  }
}
</style>
